import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_VECTR_API_URL || 'https://api.vectr.ai/v1'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export interface VectrWorkflow {
  id: string
  workflow_id: string
  account_id: string
  user_id: string
  title?: string
  status: 'provisioning' | 'active' | 'failed' | 'publishing_queued' | 'publishing' | 'published' | 'unpublished'
  workflow_status: 'provisioning' | 'active' | 'failed' | 'publishing_queued' | 'publishing' | 'published' | 'unpublished'
  initial_prompt?: string
  created_at: string
  last_published?: string
  last_publish_elapsed?: number
  container_application_id?: string
}

export interface VectrAccount {
  id: string
  name: string
  created_at: string
  updated_at: string
}

export const vectrApi = {
  async getAccounts(): Promise<VectrAccount[]> {
    const response = await api.get('/accounts')
    return response.data
  },

  async getAccount(accountId: string): Promise<VectrAccount> {
    const response = await api.get(`/accounts/${accountId}`)
    return response.data
  },

  async getWorkflows(accountId?: string): Promise<VectrWorkflow[]> {
    const url = accountId ? `/accounts/${accountId}/workflows` : '/workflows'
    const response = await api.get(url)
    return response.data
  },

  async getWorkflow(accountId: string, workflowId: string): Promise<VectrWorkflow> {
    const response = await api.get(`/accounts/${accountId}/workflows/${workflowId}`)
    return response.data
  },

  async createWorkflow(accountId: string, prompt: string): Promise<VectrWorkflow> {
    const response = await api.post(`/accounts/${accountId}/workflows`, { prompt })
    return response.data
  },

  async publishWorkflow(accountId: string, workflowId: string): Promise<void> {
    await api.post(`/accounts/${accountId}/workflows/${workflowId}/publish`)
  },

  async redeployAgent(accountId: string, workflowId: string): Promise<void> {
    await api.post(`/accounts/${accountId}/workflows/${workflowId}/redeploy-agent`)
  },

  async deleteWorkflow(accountId: string, workflowId: string): Promise<void> {
    await api.delete(`/accounts/${accountId}/workflows/${workflowId}`)
  }
}



